////////////////////////////////////////////////////////////////////////////////
//
// Store transcribe pairs module
//
////////////////////////////////////////////////////////////////////////////////

import { Mutation } from "@/store/mutations";
import { Action } from "@/store/actions";
import ApiService from "@/services/api.service";

const state = {
  pairs: [],
};

const getters = {
  pairById: (state) => (id) => state.pairs.find((p) => p.id === id),
  isDevicePaired: (state) => (deviceId) =>
    state.pairs.some((p) =>
      (p.members || []).some((m) => m.device_id === deviceId)
    ),
  pairedDeviceIds: (state) => {
    const ids = new Set();
    state.pairs.forEach((p) =>
      (p.members || []).forEach((m) => ids.add(m.device_id))
    );
    return ids;
  },
};

const actions = {
  async [Action.transcribePair.load](context) {
    try {
      const result = await ApiService.transcribe_pairs.all();
      const pairs = result.data.data.pairs || [];
      context.commit(Mutation.transcribePair.set, pairs);
      return pairs;
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },

  async [Action.transcribePair.add](context, payload) {
    try {
      const result = await ApiService.transcribe_pairs.add(payload);
      context.commit(Mutation.notify, {
        message: "Pair created",
        type: "success",
      });
      return result.data.data;
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },

  async [Action.transcribePair.delete](context, pairId) {
    try {
      await ApiService.transcribe_pairs.del(pairId);
      context.commit(Mutation.notify, {
        message: "Pair deactivated",
        type: "success",
      });
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
};

const mutations = {
  [Mutation.transcribePair.set](state, pairs) {
    state.pairs = pairs;
  },
};

const transcribePair = {
  state,
  getters,
  actions,
  mutations,
};

export default transcribePair;